import {
  CATEGORY_TYPE_MARKETPLACE,
  CATEGORY_TYPE_LEADS,
  CATEGORY_TYPE_DIRECTORY,
  CATEGORY_TYPE_AUCTION,
} from './marketplace';

export const LAUNCH_CATEGORY_TYPE_MARKETPLACE = 'marketplace';
export const LAUNCH_CATEGORY_TYPE_CLASSIFIEDS = 'classifieds';
export const LAUNCH_CATEGORY_TYPE_DIRECTORY = 'directory';
export const LAUNCH_CATEGORY_TYPE_MATCHMAKING = 'matchmaking';
export const LAUNCH_CATEGORY_TYPE_JOBBOARD = 'jobboard';
export const LAUNCH_CATEGORY_TYPE_REALESTATE = 'realestate';
export const LAUNCH_CATEGORY_TYPE_EVENTS = 'events';
export const LAUNCH_CATEGORY_TYPE_OTHER = 'other';

export const LAUNCH_TO_BACKEND_CATEGORY_TYPE_MAP: Record<string, string> = {
  [LAUNCH_CATEGORY_TYPE_MARKETPLACE]: CATEGORY_TYPE_MARKETPLACE,
  [LAUNCH_CATEGORY_TYPE_OTHER]: CATEGORY_TYPE_MARKETPLACE,
  [LAUNCH_CATEGORY_TYPE_CLASSIFIEDS]: CATEGORY_TYPE_LEADS,
  [LAUNCH_CATEGORY_TYPE_JOBBOARD]: CATEGORY_TYPE_LEADS,
  [LAUNCH_CATEGORY_TYPE_REALESTATE]: CATEGORY_TYPE_LEADS,
  [LAUNCH_CATEGORY_TYPE_DIRECTORY]: CATEGORY_TYPE_DIRECTORY,
  [LAUNCH_CATEGORY_TYPE_MATCHMAKING]: CATEGORY_TYPE_DIRECTORY,
  [LAUNCH_CATEGORY_TYPE_EVENTS]: CATEGORY_TYPE_DIRECTORY,
};

export const BACKEND_TO_LAUNCH_CATEGORY_TYPE_MAP: Record<string, string[]> = {
  [CATEGORY_TYPE_MARKETPLACE]: [LAUNCH_CATEGORY_TYPE_MARKETPLACE, LAUNCH_CATEGORY_TYPE_OTHER],
  [CATEGORY_TYPE_LEADS]: [
    LAUNCH_CATEGORY_TYPE_CLASSIFIEDS,
    LAUNCH_CATEGORY_TYPE_JOBBOARD,
    LAUNCH_CATEGORY_TYPE_REALESTATE,
  ],
  [CATEGORY_TYPE_DIRECTORY]: [
    LAUNCH_CATEGORY_TYPE_DIRECTORY,
    LAUNCH_CATEGORY_TYPE_MATCHMAKING,
    LAUNCH_CATEGORY_TYPE_EVENTS,
  ],
  [CATEGORY_TYPE_AUCTION]: [],
};

export const LAUNCH_CATEGORY_TYPE_OPTIONS = [
  {
    value: LAUNCH_CATEGORY_TYPE_MARKETPLACE,
    label: 'Peer-to-Peer e-Commerce',
    description: "Buyers pay directly through marketplace. Fees are deducted from seller's payout.",
    backendType: CATEGORY_TYPE_MARKETPLACE,
  },
  {
    value: LAUNCH_CATEGORY_TYPE_CLASSIFIEDS,
    label: 'Classifieds',
    description:
      'Sellers create listings, sometimes for a fee. Buyers and sellers negotiate transactions themselves outside of marketplace.',
    backendType: CATEGORY_TYPE_LEADS,
  },
  {
    value: LAUNCH_CATEGORY_TYPE_DIRECTORY,
    label: 'Business or Services Directory',
    description:
      'Sellers can list their services, sometimes for a fee. Buyers and sellers negotiate transactions themselves outside of marketplace.',
    backendType: CATEGORY_TYPE_DIRECTORY,
  },
  {
    value: LAUNCH_CATEGORY_TYPE_MATCHMAKING,
    label: 'Matchmaking or Dating',
    description: 'Users can list themselves or respond to listings.',
    backendType: CATEGORY_TYPE_DIRECTORY,
  },
  {
    value: LAUNCH_CATEGORY_TYPE_JOBBOARD,
    label: 'Job Board',
    description: 'List jobs opportunities or availability to work.',
    backendType: CATEGORY_TYPE_LEADS,
  },
  {
    value: LAUNCH_CATEGORY_TYPE_REALESTATE,
    label: 'Real Estate for Sale or Rent',
    description: 'List properties for sale or rent.',
    backendType: CATEGORY_TYPE_LEADS,
  },
  {
    value: LAUNCH_CATEGORY_TYPE_EVENTS,
    label: 'Event Directory & Calendar',
    description: 'Create a calendar of events.',
    backendType: CATEGORY_TYPE_DIRECTORY,
  },
  {
    value: LAUNCH_CATEGORY_TYPE_OTHER,
    label: 'Build Your Own',
    description: 'Fully customize your category using advanced settings.',
    backendType: CATEGORY_TYPE_MARKETPLACE,
  },
];

export const filterLaunchCategoryTypesByTier = (enabledBackendTypes: string[]) => {
  return LAUNCH_CATEGORY_TYPE_OPTIONS.filter((option) =>
    enabledBackendTypes.includes(option.backendType),
  );
};

export const CATEGORY_TYPE_OPTIONS = [
  {
    value: CATEGORY_TYPE_MARKETPLACE,
    label: 'Marketplace',
    description: "Buyers pay directly through marketplace. Fees are deducted from seller's payout.",
  },
  {
    value: CATEGORY_TYPE_LEADS,
    label: 'Listing + Leads',
    description:
      'Sellers create listings, sometimes for a fee. Buyers and sellers negotiate transactions themselves outside of marketplace.',
  },
  {
    value: CATEGORY_TYPE_DIRECTORY,
    label: 'Directory',
    description:
      'Sellers can list their services, sometimes for a fee. Buyers and sellers negotiate transactions themselves outside of marketplace.',
  },
  {
    value: CATEGORY_TYPE_AUCTION,
    label: 'Auction',
    description:
      'Sellers can put a single item up for a time-based auction. Requires marketplace admin approval.',
  },
];
